import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CoreServiceService } from '../core/core-service.service';
import { MasterCustomer } from '../Models/master-customer';
import { MasterCustomerRechargeRenew } from '../Models/master-customer-recharge-renew';
import { MASTER_CUSTOMERS_WITH_VEHICLE } from '../Models/master-customer-with-vehicle';
import { MASTER_PAYMENT_TYPE } from '../Models/master-payment-type';
import { Status } from '../Models/status';

@Injectable({
  providedIn: 'root'
})
export class CustomerApiService {

  private BaseApiPath: string;
  constructor(private http: HttpClient, private coreService: CoreServiceService) {

    this.BaseApiPath = this.coreService.appSettings && this.coreService.appSettings.ParkBaseApiPath;

  }
  public getSearchedCustomers(search: string): Observable<MasterCustomer[]> {
    const ApiUrl = this.BaseApiPath + 'customer/searchcustomer';
    return this.http.post<MasterCustomer[]>(ApiUrl, { Status_msg: search });
  }
  public getSearchedCustomersNonBusiness(search: string): Observable<MasterCustomer[]> {
    const ApiUrl = this.BaseApiPath + 'customer/searchcustomernonbusiness';
    return this.http.post<MasterCustomer[]>(ApiUrl, { Status_msg: search });
  }
  public InsertUpdateCustomer(masterCustomer: MasterCustomer): Observable<Status<string>> {
    const ApiUrl = this.BaseApiPath + 'customer/InsertUpdateCustomer';
    return this.http.post<Status<string>>(ApiUrl, masterCustomer);
  }
  public getCustomers(): Observable<MasterCustomer[]> {
    const ApiUrl = this.BaseApiPath + 'customer/getcustomers';
    return this.http.get<MasterCustomer[]>(ApiUrl);
  }
  public GET_MASTER_PAYMENT_TYPE(): Observable<MASTER_PAYMENT_TYPE[]> {
    const ApiUrl = this.BaseApiPath + 'customer/GET_MASTER_PAYMENT_TYPE';
    return this.http.get<MASTER_PAYMENT_TYPE[]>(ApiUrl);
  }
  public GET_CUSTOMER_WITH_VEHICLE(): Observable<MASTER_CUSTOMERS_WITH_VEHICLE[]> {
    const ApiUrl = this.BaseApiPath + 'customer/GET_CUSTOMER_WITH_VEHICLE';
    return this.http.get<MASTER_CUSTOMERS_WITH_VEHICLE[]>(ApiUrl);
  }
  public getCustomer(masterCustomer: MasterCustomer): Observable<MasterCustomer> {
    const ApiUrl = this.BaseApiPath + 'customer/getCustomer';
    return this.http.post<MasterCustomer>(ApiUrl, masterCustomer);
  }
  public DeleteFromMasterCustomers(masterCustomer: MasterCustomer): Observable<Status<string>> {
    const ApiUrl = this.BaseApiPath + 'customer/DeleteFromMasterCustomers';
    return this.http.post<Status<string>>(ApiUrl, masterCustomer);
  }
  public InsertUpdateMasterCustomersRechargeRenew(masterCustomerRechargeRenew: MasterCustomerRechargeRenew): Observable<Status<string>> {
    const ApiUrl = this.BaseApiPath + 'customer/InsertUpdateMasterCustomersRechargeRenew';
    return this.http.post<Status<string>>(ApiUrl, masterCustomerRechargeRenew);
  }
  public MasterCustomerRechargeRenew(masterCustomerRechargeRenew: MasterCustomerRechargeRenew): Observable<MasterCustomerRechargeRenew> {
    const ApiUrl = this.BaseApiPath + 'customer/MasterCustomerRechargeRenew';
    return this.http.post<MasterCustomerRechargeRenew>(ApiUrl, masterCustomerRechargeRenew);
  }
}
